/**
 * PROMOTED COURSES CONFIGURATION
 * 
 * Courses listed here rotate in the announcement banner and sliding popup.
 * Add new courses at the top of the array to feature them first.
 */

import { AI_COURSE_IMAGES } from './courseImages';

export interface PromotedCourse {
  id: string;
  title: string;
  shortTitle: string;
  description: string;
  url: string;
  image: string;
  badge: string;
  gradient: string;
}

export const PROMOTED_COURSES: PromotedCourse[] = [
  {
    id: 'ai-red-teaming-promptfoo',
    title: 'Red Teaming AI Apps with Promptfoo: RAG, Chatbots & Agents',
    shortTitle: 'AI Red Teaming with Promptfoo',
    description: 'Find and fix AI security risks with jailbreaks, OWASP techniques, policies, plugins, and real-world RAG attacks',
    url: 'https://www.udemy.com/course/ai-red-teaming-promptfoo-rag-chatbots-agents/',
    image: AI_COURSE_IMAGES['ai-red-teaming-promptfoo-rag-chatbots-agents'],
    badge: '🆕 NEW AI SECURITY COURSE',
    gradient: 'from-red-600 via-rose-600 to-orange-600',
  },
  {
    id: 'zero-code-ai-testing',
    title: 'ZERO Code AI Tests: Automate Software Tests in Plain English',
    shortTitle: 'ZERO Code AI Tests in Plain English',
    description: 'Automate software tests without writing a single line of code using AI',
    url: 'https://www.udemy.com/course/zero-code-ai-testing/?couponCode=EA_LAUNCH_26',
    image: AI_COURSE_IMAGES['zero-code-ai-testing'],
    badge: '🆕 NEW COURSE',
    gradient: 'from-emerald-600 via-teal-600 to-emerald-600',
  },
  {
    id: 'ai-test-automation',
    title: 'AI-Driven Test Automation: Playwright, Selenium, LLMs & More',
    shortTitle: 'AI-Driven Test Automation with LLMs',
    description: 'Build intelligent self-healing frameworks with Playwright, Selenium & LLMs',
    url: 'https://www.udemy.com/course/ai-test-automation-selenium-playwright-llms/?couponCode=EA_LAUNCH_26',
    image: AI_COURSE_IMAGES['ai-test-automation-selenium-playwright-llms'],
    badge: '🎉 NEW COURSE ALERT',
    gradient: 'from-indigo-600 via-blue-600 to-indigo-600',
  },
];

/** Rotation interval in milliseconds */
export const ROTATION_INTERVAL = 5000;
